import * as _ from 'gleam:prelude'
import * as $position from './position.mjs'

export function getParentPosition(target) {
  while (target && !containsClass(target)) target = target.parentElement
  if (!target) return _.Result$Error('No parent wrapper')
  if (!target.getBoundingClientRect)
    return _.Result$Error('No bounding rect function')
  const rect = target.getBoundingClientRect()
  if (!rect) return _.Result$Error('No bounding rect')
  return _.Result$Ok(
    $position.Box$Box(
      rect.top,
      rect.bottom,
      rect.left,
      rect.right,
      rect.width,
      rect.height,
      rect.x,
      rect.y
    )
  )
}

function containsClass(el) {
  const klass = el.getAttribute('class')
  const isWrapper = klass?.includes?.($position.wrapper_class)
  return isWrapper ?? false
}
